import type {
  PaginationDispatchProps,
  PaginationStateProps,
} from 'components/shared/Blotter/Pagination/Pagination.model';
import { connect } from 'react-redux';
import {
  secondaryMarketTradeBlotterItemsPerPageChanged,
  secondaryMarketTradeBlotterPageChanged,
} from 'state/blotters/secondaryMarketTradeBlotter';
import { getSecondaryMarketTradeBlotterPreferenceState } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import { getSecondaryMarketTradeBlotterPaginationInfo } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export const mapStateToProps = (state: AppState): PaginationStateProps => {
  const { page, totalItems } = getSecondaryMarketTradeBlotterPaginationInfo(state);
  return {
    page,
    itemsPerPage: getSecondaryMarketTradeBlotterPreferenceState(state.blotters.secondaryMarket).pageSizeState,
    totalItems,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): PaginationDispatchProps => ({
  onSizeChanged(size) {
    dispatch(secondaryMarketTradeBlotterItemsPerPageChanged(size));
  },
  onPageChanged(page: number) {
    dispatch(secondaryMarketTradeBlotterPageChanged(page));
  },
});

export const connectPaginationComponent = connect(mapStateToProps, mapDispatchToProps);
